module.exports = __webpack_public_path__ + "static/media/wifi-level-2-mobile.7c725c85.svg";